export const ConciliationFileStatus = {
    PENDENT: 1,
    OK: 2,
};

export const ConciliationFileStatusMap = new Map([
    [ConciliationFileStatus.OK, 'OK'],
    [ConciliationFileStatus.PENDING, 'PENDING'],
]);